import type { IntlShape } from 'react-intl';
import type { RadioGroupOption } from '../../common/FormFields/RadioGroupInput/RadioGroupInput';

export type ControlArea =
  | 'apg'
  | 'tennet'
  | '50hertz'
  | 'amprion'
  | 'transnetBW'
  | 'custom';

export function isCustomControlArea(
  value: string | null | undefined
): value is 'custom' {
  return value === 'custom';
}

export function getControlAreaRadioOptions(
  intl: IntlShape,
  otherMessageId = 'offerWizard.regelzone.other'
): RadioGroupOption[] {
  return [
    { value: 'apg', labelText: 'APG' },
    { value: 'tennet', labelText: 'TenneT' },
    { value: '50hertz', labelText: '50 Hertz' },
    { value: 'amprion', labelText: 'Amprion' },
    { value: 'transnetBW', labelText: 'Transnet BW' },
    {
      value: 'custom',
      labelText: intl.formatMessage({ id: otherMessageId }),
    },
  ];
}
